<template>
  <div>
    <v-container justify="center" v-if="!loading">
      <v-row justify="center" class="mt-n8">
        <span class="text-h6"> {{ dataEntry.diary_book_type_name }}</span>
      </v-row>
      <v-row justify="center" class="">
        <span class="text-body-2">
          {{ dataEntry.business_unit_description }}</span
        >
      </v-row>
      <v-row justify="center">
        <span class="text-body-2"> {{ dataEntry.note }}</span>
      </v-row>
      <v-row class="mx-6 mt-n8">
        <span class="text-body-2"> {{ dataEntry.diary_book_code }}</span>
        <v-spacer></v-spacer>{{ getDate(dataEntry.effective_date) }}
      </v-row>
      <v-row justify="center">
        <v-container>
          <v-data-table
            fixed-header
            dense
            hide-default-footer
            :items-per-page="20"
            :headers="headers"
            :items="dataEntry.diary_book_details"
            class="elevation-1 rounded-lg"
            height="60vh"
            @page-count="pageCount = $event"
            :page.sync="page"
            :search="search"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  class="mt-4"
                  placeholder="Buscar..."
                ></v-text-field>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>

            <!-- <template v-slot:[`item.created_date`]="{ item }">
               <span class="font-weight-normal subtitle-3">
                 {{ getDate(item.created_date) }}</span>
             </template> -->
            <template v-slot:[`item.chart_of_account_name`]="{ item }">
              <span class="primary--text"
                >{{ item.chart_of_account_code }}
              </span>
              - {{ item.chart_of_account_name }}
            </template>

            <template v-slot:[`item.entity_name`]="{ item }">
              <v-hover v-slot="{ hover }">
                <span
                  @click="viewEntity(item.entity_id, true)"
                  style="font-size: 14px"
                  class="primary--text font-weight-normal text-truncate font-weight-semibold"
                  :style="{
                    color: hover ? 'red' : 'black',
                    cursor: hover ? 'pointer' : '',
                    'text-decoration': hover ? 'underline' : '',
                  }"
                  >{{ item.entity_name }}</span
                ></v-hover
              >
            </template>
            <template v-slot:[`item.department_id`]="{ item }">
              <span class="primary--text">{{ item.department_id }} </span>
              <span v-if="item.departments != null">
                - {{ item.departments[0].name }}</span
              >
            </template>
            <template v-slot:[`item.debito`]="{ item }">
              <template v-if="item.entry_type_id == 1">
              <span >
                {{
                  item.amount.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })
                }}
                {{ item.currency_code }}
              </span>
         
              </template>
            </template>

            <template v-slot:[`item.credito`]="{ item }">
              <template  v-if="item.entry_type_id == 2">
              <span >
                {{
                  item.amount.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })
                }}
                {{ item.currency_code }}
              </span>
              
              </template>
            </template>

            <template slot="body.append">
              <!-- <tr class="mt-2 mb-2" v-for="(item, i) of debitoAndCredito.arrayCurrency" :key="i">
                 <th></th>
                 <th></th>
                 <th></th>
                 <th></th>
                 <th></th>
                 <th class="font-weight-bold" style="color: #607d8b; font-size: 18px">
                   TOTAL {{ item.currency }}
                 </th>
  
                 <th style="font-size: 16px" class="font-weight-bold text-right success--text">
                   {{ currencyFormat(item.debito) }} {{ item.currency }}
                 </th>
                 <th class="font-weight-bold text-right error--text" style="font-size: 16px">
                   {{ currencyFormat(item.credito) }} {{ item.currency }}
                 </th>
               </tr> -->
            </template>
            <template slot="footer">
              <v-row justify="center">
                <v-container style="width: 70%">
                  <v-pagination
                    v-model="page"
                    :length="pageCount"
                  ></v-pagination>
                </v-container>
              </v-row>

              <v-row justify="end">
                <v-col cols="12" md="3">
                  <span
                    class="font-weight-bold"
                    style="color: #607d8b; font-size: 24px"
                  >
                    TOTAL
                  </span>
                </v-col>
                <v-col cols="12" md="2">
                  <th
                    style="font-size: 20px"
                    class="font-weight-bold text-right success--text"
                  >
                    {{ currencyFormat(debitoAndCredito.debito) }}

                 <span v-if="dataEntry&&dataEntry.diary_book_details">{{dataEntry.diary_book_details[0].currency_code}}</span>   
                  </th>
                </v-col>
                <v-col cols="12" md="2">
                  <th
                    class="font-weight-bold text-right error--text"
                    style="font-size: 20px"
                  >
                    {{ currencyFormat(debitoAndCredito.credito) }}
                    <span v-if="dataEntry&&dataEntry.diary_book_details">{{dataEntry.diary_book_details[0].currency_code}}</span>   
                  </th>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-container>
      </v-row>
    </v-container>
    <v-row v-else justify="center">
      <v-col cols="12" md="10">
        <v-skeleton-loader
          type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
        >
        </v-skeleton-loader>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import moment from "moment";

//import SearchHeader from "../../components/SearchHeader.vue";
export default {
  data: () => ({
    page: 1,
    dataEntry: {},
    pageCount: 0,
    search: "",
    loading: false,
    sortBy: "entity_id",
    sortDesc: false,
    headers: [
     
      {
        text: "Location",
        value: "location_description",
        align: "center",
      },
      //  { text: "Fecha", value: "created_date", width: "10%", align: "center" },

      { text: "Cuenta contable", value: "chart_of_account_name" },
      { text: "Categoría", value: "category_name" },
      { text: "Sub categoría", value: "subcategory_name" },

      { text: "Débito", value: "debito", align: "end" },
      { text: "Crédito", value: "credito", align: "end" },
    ],
  }),
  created() {
    this.getData();
  },

  computed: {
    debitoAndCredito() {
      let debito = 0;
      let credito = 0;
      let arrayDebito = [];
      let arrayCurrency = [];
      let deb = 0;
      let cre = 0;

      if (this.dataEntry.diary_book_details != null) {
        this.dataEntry.diary_book_details.forEach((element) => {
          if (element.entry_type_id == 1) {
            debito += parseFloat(element.amount);
            deb = parseFloat(element.amount);
          }
        });

        this.dataEntry.diary_book_details.forEach((element) => {
          if (element.entry_type_id == 2) {
            credito += parseFloat(element.amount);
            cre = parseFloat(element.amount);
          }
        });

        arrayCurrency.push({
          debito: deb,
          credito: cre,
        });
      }

      let resultArray = [];

      arrayCurrency.reduce(function (res, value) {
        if (!res[value.currency]) {
          res[value.currency] = {
            currency: value.currency,
            debito: value.debito,
            credito: value.credito,
          };
          resultArray.push(res[value.currency]);
        }
        res[value.currency].debito += value.debito;
        res[value.currency].credito += value.credito;
        return res;
      }, {});

      return {
        debito: debito,
        credito: credito,
        arrayCurrency: resultArray,
      };
    },
  },

  methods: {
    getDate(date) {
      let newDate = moment(date).format("DD-MM-YYYY").toString();
      return newDate;
    },

    async getData() {
      this.loading = true;
      let id = this.$route.params.id;

      let filters = " and diary_book_id=" + id + " ";
      const responseRequest = await this.api_Post("accounting/diary_book", {
        filtros: filters,
      });
      let data = await responseRequest.json();
   
      this.dataEntry = data[0];

      this.loading = false;
    },
  },
};
</script>
